// Customer-document labels only; never rewrite the stored product name.
export const formatDocumentProductTitle = (rawName) => {
  const name = String(rawName ?? '').trim();
  const leading = name.match(/^\*\*([^*]+)\*\*\s*/);
  if (!leading) return name.replace(/\*\*([^*]+)\*\*/g, '$1');
  const label = leading[1].trim();
  const rest = name.slice(leading[0].length).replace(/\*\*([^*]+)\*\*/g, '$1').trim();
  return rest ? label + ' — ' + rest : label;
};
